import { Component, OnInit, Input, Output, EventEmitter, ViewChild, TemplateRef, ViewChildren, QueryList, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { ProspectModel } from '../../../shared/models/ProspectModel';
import { FormGroup, FormControl, Validators, DefaultValueAccessor } from '@angular/forms';
import { spaceOnlyValidator } from '../../../shared/models/SavePropertyInputModel';
import { ILookUp } from '../../../shared/models/LookUpOutputModel';
import { CommonService } from '../../../shared/providers/common.service';
import { DashboardService } from '../../../shared/providers/dashboard.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { LoaderService } from '../../../shared/providers/loader.service';
import { PropertyManagementService } from '../../../shared/providers/property-management.service';
import { FileUploadService } from '../../../shared/providers/fileupload.service';
import { IFileUpload } from '../../../shared/models/fileupload';
import { ToastService } from '../../../shared/providers/toast.service';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { ValidationService } from '../../../shared/providers/validation.service';
import { IImportProspectsProperties } from '../../../shared/models/ImportProspectsProperties';
import { DataTablesResponse } from '../../../shared/models/datatables-response';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { IProspectDetailsModel } from '../../../shared/models/ProspectDetailsforImport';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { IImportProspectInputModel } from '../../../shared/models/ImportProspectInputModel';
import { PropertyListingService } from '../../../shared/providers/property-listing.service';
import { MatSelect, MAT_SELECT_CONFIG } from '@angular/material/select';
enum Menus {
  SelectedProperties = 1,
  ImportProspects = 2,
  Preview = 3,
}
@Component({
  selector: 'app-import-prospects-add',
  templateUrl: './import-prospects-add.component.html',
  styleUrls: ['./import-prospects-add.component.css'],
})
export class ImportProspects implements OnInit {

  @Input() propertyId: number;
  @Input() propertyType: number[];
  @Input() category: number[];
  @Output() save = new EventEmitter();
  @Output() close = new EventEmitter();
  @Input() IsPortfolio: boolean;
  activePage: number
  removeModalRef: BsModalRef;
  menu = Menus;
  importProperties: IImportProspectsProperties[] = [];
  importProspects: IProspectDetailsModel[] = [];
  selectedRows: IImportProspectsProperties[] = [];
  selectedProspects: IProspectDetailsModel[] = [];
  selectedProspectList: IProspectDetailsModel[] = [];
  activeMenu = Menus.SelectedProperties;
  @ViewChild('template') template: TemplateRef<any>;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  @ViewChildren(MatSelect) matSelects!: QueryList<MatSelect>;
  user: any;
  DDColumns = [];
  prospectColumns = [];
  ImportColumns = [];
  dtoptions = {};
  prospectoptions = {};
  previewoptions = {};
  dtTrigger: Subject<any> = new Subject();
  table: DataTableDirective;
  apiUrl: string;
  OfferOnId: number = 0;
  characterLimit: number = 80;
  IsShowCollapse: boolean = false;
  searchNote: string = '';
  propertySearchNote: string = '';
  propertySearchNote1: string = '';
  protected readonly BASE_URL: string = environment.base_url;
  IsDataProcessing: boolean = false;
  selectedCheckboxDataLimit: number = 5;
  IsSelectedPropertyOpened: boolean = false;
  IsSelectedProspectOpened: boolean = false;
  IsSelectedPreviewOpened: boolean = false;
  inputAssetTypes = [];
  selectedAssetTypes: number[];
  inputSubCategory = [];
  selectedSubCategories: number[];
  inputBroker = [];
  selectedBrokers: number[] = [];
  IsInitalLoad: boolean = true;
  defaultBrokerList: number[] = [];
  selectedBrokersCopy: number[] = [];
  selectedSubCategoriesCopy: number[];
  selectedAssetTypesCopy: number[];
  prospectSearch: string = '';
  previewSearch: string = '';
  importProspectInputModel = {} as IImportProspectInputModel;
  allProspects: IProspectDetailsModel[] = [];
  selectedSearch: string = '';
  allProspectCount: number;
  IsArchived: boolean = false;
  //defaultTypeText: IMultiSelectTexts = {
  //  checked: 'Property Type selected',
  //  checkedPlural: 'Property Types selected',
  //  defaultTitle: 'Select Property Type'
  //};
  //defaultBrokerText: IMultiSelectTexts = {
  //  checked: 'Broker selected',
  //  checkedPlural: 'Brokers selected',
  //  defaultTitle: 'Select Broker'
  //};
  //defaultSubCategoryText: IMultiSelectTexts = {
  //  checked: 'Subcategory selected',
  //  checkedPlural: 'Subcategories selected',
  //  defaultTitle: 'Select Subcategory'
  //};
  defaultTypeSettings = {
    singleSelection: false,
    text: "Select Property Type",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
    badgeShowLimit: 2
  }
  defaultCategorySettings = {
    singleSelection: false,
    text: "Select Subcategory",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
    badgeShowLimit: 2
  }
  defaultBrokerSettings = {
    singleSelection: false,
    text: "Select Broker",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
    badgeShowLimit: 2
  }

  constructor(private _commonService: CommonService,
    private http: HttpClient,
    private renderer: Renderer2,
    private _dashboardService: DashboardService,
    private _modalService: BsModalService,
    private _loaderService: LoaderService,
    private _propertyManagementService: PropertyManagementService,
    private _propertyListingService: PropertyListingService,
    private _toastService: ToastService,
    private _authenticationService: AuthenticationService,
    private _validationService: ValidationService,
    private router: Router, private cdRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.user = this._authenticationService.user;
    this.getBrokers();
    this.getAssetTypes();


    this.apiUrl = '/property/GetImportProspectPropertyList';
    if (this.IsPortfolio) {
      this.OfferOnId = 6002
    }
    else {
      this.OfferOnId = 6001
    }
    this.selectAllProspects = false;
    this.selectAll = false;

    if (this.propertyType != null && this.propertyType.length > 0) {
      this.selectedAssetTypes = this.propertyType.map(p => p);
      if (this.category != null && this.category.length > 0) {
        this.selectedSubCategories = this.category.map(c => c);;
      }
      this.bindSubCategoroes();
    }
    this.getPropertiesForImport();
    this.selectedSubCategoriesCopy = this.selectedSubCategories.map(o => o);
    this.selectedAssetTypesCopy = this.selectedAssetTypes.map(o => o);
    this.selectedBrokersCopy = this.selectedBrokers.map(o => o);
  }

  ngAfterViewInit() {
    this.matSelects.forEach((matSelect) => {
      matSelect.openedChange.subscribe((isOpened) => {
        if (isOpened) {
          this.addClassToOverlayContainer();
        } else {
          this.removeClassFromOverlayContainer();
        }
      });
    });
  }

  private addClassToOverlayContainer() {
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (overlayContainer) {
      this.renderer.addClass(overlayContainer, 'custom-overlay-container');
    }
  }

  private removeClassFromOverlayContainer() {
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (overlayContainer) {
      this.renderer.removeClass(overlayContainer, 'custom-overlay-container');
    }
  }

  onClose() {
    this.close.emit();
  }

  IsTabClicked = false;
  dtInstance: any;
  setMenuID(id) {
    this.IsTabClicked = false;
    let loadStatus = false;
    if (id == this.menu.ImportProspects) {
      if (this.selectedRows == null || this.selectedRows.length <= 0) {
        this._toastService.addToast({ title: 'Error', msg: "Please select the Properties", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
      else {
        this.apiUrl = '/property/importProspectList';
        this.activeMenu = id;
        loadStatus = true;
      }
    }
    else if (id == this.menu.SelectedProperties) {
      this.propertySearchNote = this.propertySearchNote1;
      this.apiUrl = '/property/GetImportProspectPropertyList';
      loadStatus = true;
    }
    else {
      if (this.selectedProspects == null || this.selectedProspects.length <= 0) {
        this._toastService.addToast({ title: 'Error', msg: "Please select the Prospects", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
      else {
        this.apiUrl = '/property/importProspectList';
        loadStatus = true;
      }
    }
    if (loadStatus) {
      this.searchNote = '';
      $(".dataTables_paginate.paging_full_numbers").hide();
      if (this.dtoptions != null && this.dtoptions != undefined) {
        if (id == this.menu.SelectedProperties) {
          this.dtoptions['aaSorting'] = [[6, "desc"]];
          this.dtoptions['order'] = [[6, "desc"]];
          $('th.prospectCount').click();
          if ($("th.prospectCount").hasClass("sorting_desc")) {
          }
          else {
            $('th.prospectCount').click();
          }
        }
        else {
          $('th.prospectId').click();
          if ($("th.prospectId").hasClass("sorting_desc")) {
          }
          else {
            $('th.prospectId').click();
          }
          $("th.prospectId").addClass("sorting_desc");
          this.dtoptions['aaSorting'] = [[7, "desc"]];
          this.dtoptions['order'] = [[7, "desc"]];
        }
      }
      this.IsTabClicked = true;
      let noteText = '';
      if (id == this.menu.SelectedProperties) {
        this.selectedSubCategories = this.selectedSubCategoriesCopy.map(o => o);
        this.selectedAssetTypes = this.selectedAssetTypesCopy.map(o => o);
        this.selectedBrokers = this.selectedBrokersCopy.map(o => o);
        this.searchNote = this.selectedSearch;
        noteText = this.selectedSearch;
      }
      else if (id == this.menu.ImportProspects) {
        this.searchNote = this.prospectSearch;
        noteText = this.prospectSearch;
      }
      else {
        this.searchNote = this.previewSearch;
        noteText = this.previewSearch;
      }
      if (noteText != null && noteText != '') {
        this.activeMenu = id;
        this.dtElement.dtInstance.then(x => x.search(noteText).draw(false));
      }
      else {
        this.activeMenu = id;
        this.dtElement.dtInstance.then(x => x.search('').draw(false));
      }
    }
  }


  getPropertiesForImport() {
    let columns = [
      { data: 'IsSelected' },
      { data: 'IsSelected' },
      { data: 'PropertyName' },
      { data: 'State' },
      { data: 'City' },
      { data: 'Status' },
      { data: 'ProspectCount' },
      { data: 'ProspectName' },
      { data: 'Company' }
    ];

    this.DDColumns = columns;
    const that = this;
    this.dtoptions = {
      pagingType: 'full_numbers',
      "pageLength": 20,
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
      },
      "order": [[(this.activeMenu == this.menu.SelectedProperties ? 6 : 7), "desc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsDataProcessing = true;
        this.defaultBrokerList.push(this.user.Id);
        if (this.IsInitalLoad && this._authenticationService.Broker()) {
          this.selectedBrokers = this.defaultBrokerList;
          this.IsInitalLoad = false;
        }
        dataTablesParameters.Extra_param = {
          UserId: that.user.Id,
          PropertyLst: this.selectedRows.map(i => i.Id),
          ProspectMasterList: this.selectedProspects.map(i => i.Id),
          PortfolioActiveTab: this.activeMenu,
          AssetTypes: this.selectedAssetTypes,
          SubCategories: this.selectedSubCategories,
          BrokerList: this.selectedBrokers,
          PropertyId: this.propertyId != null && this.propertyId > 0 ? this.propertyId : 0,
          IsArchive: this.IsArchived
        }
        if (this.IsTabClicked) {
          const orderData = {
            column: this.activeMenu == this.menu.SelectedProperties ? 6 : 7,
            dir: "desc"
          };
          dataTablesParameters['order'] = [orderData];
          dataTablesParameters['start'] = 0;

          $(".paginate_button.first").click();
        }
        this.IsSelectedPropertyOpened = false;
        this.IsSelectedProspectOpened = false;
        this.IsSelectedPreviewOpened = false;
        let url = this.BASE_URL + this.apiUrl;
        const httpHeader = this._validationService.GetAuthHeader();
        that.http.post<DataTablesResponse>(
          url, dataTablesParameters, httpHeader).subscribe(resp => {
            if (resp != null) {

              if (this.apiUrl.indexOf("/property/GetImportProspectPropertyList") > -1) {
                this.setPropertyList(resp);
              }
              else if (this.apiUrl.indexOf("/property/importProspectList") > -1 && this.activeMenu == this.menu.ImportProspects) {
                this.setProspectList(resp);
              }
              else {
                this.setPreviewList(resp);
              }
              this.IsTabClicked = false;
              this.IsDataProcessing = false;

              this._loaderService.display(false);
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data == null || resp.data.length === 0) {
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: []
                });
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
              this.IsDataProcessing = false;
            }
          });
        this._loaderService.display(false);
      },
      columns: this.DDColumns
    };
  }

  selectAll = false;
  onCheckboxChange(event, Id) {
    if (event.target.checked) {
      let prop = this.importProperties.find(x => x.Id == Id);
      this.selectedRows.push(prop);
    }
    else {
      this.selectedRows.splice(this.selectedRows.findIndex(x => x.Id == Id), 1);
    }
    this.autoSelectAll();
  }

  autoSelectAll() {
    if (this.importProperties.filter(x => x.IsSelected == true).length == this.importProperties.length && this.importProperties.length > 0) {
      this.selectAll = true;
    }
    else {
      this.selectAll = false;
    }
  }

  resetSelectedRows() {
    if (this.importProperties) {
      this.importProperties.forEach(item => {
        item.IsSelected = false;
        this.selectedProspects.splice(this.selectedProspects.findIndex(x => x.Id == item.Id, 1));
      });
      this.allProspects.forEach(item => {
        item.IsSelected = false;
        this.selectedProspects.splice(this.selectedProspects.findIndex(x => x.Id == item.Id, 1));
      });
    }
    this.autoSelectAll();
    this.selectAllProspects = false;
    this.dtElement.dtInstance.then(x => x.draw());
  }

  onSelectAll(event) {
    if (this.activeMenu == this.menu.ImportProspects) {

    }
    else if (this.activeMenu == this.menu.Preview) {

    }
    else {
      if (event.target.checked) {
        this.selectOrUnSelectAll(true);
      }
      else {
        this.selectOrUnSelectAll(false);
      }
    }
  }

  selectOrUnSelectAll(trueOrfalse) {
    this.importProperties.forEach(item => {
      item.IsSelected = trueOrfalse;
      if (trueOrfalse) {
        if (this.selectedRows.findIndex(x => x.Id == item.Id) <= -1) {
          this.selectedRows.push(item);
        }
      }
      else {
        this.selectedRows.splice(this.selectedRows.findIndex(x => x.Id == item.Id), 1);
      }
    });
    if (!trueOrfalse) {
      this.selectAll = false;
    }
  }

  onSelectedPropertyRemove(propertyId: number) {
    this.selectedRows.splice(this.selectedRows.findIndex(x => x.Id == propertyId), 1);
    this.selectAll = false;
    let currentItem = this.importProperties.find(f => f.Id == propertyId);
    if (currentItem != null) {
      currentItem.IsSelected = false;
    }
  }

  selectAllProspects = false;
  onProspectsCheckboxChange(event, Id) {
    this.hideselectionLinks = false;
    if (event.target.checked) {
      let prop = this.importProspects.find(x => x.Id == Id);
      this.selectedProspects.push(prop);
    }
    else {

      this.selectedProspects.splice(this.selectedProspects.findIndex(x => x.Id == Id), 1);
    }
    this.autoSelectAllProspects();
  }

  autoSelectAllProspects() {
    if (this.importProspects.filter(x => x.IsSelected == true).length == this.importProperties.length && this.importProperties.length > 0) {
      this.selectAllProspects = true;
    }
    else {
      this.selectAllProspects = false;
    }
  }

  onSelectAllProspects(event) {
    if (event.target.checked) {
      this.selectOrUnSelectAllProspects(true, false);
    }
    else {
      this.selectOrUnSelectAllProspects(false, false);
    }
  }

  selectOrUnSelectAllProspects(trueOrfalse, selectAll) {
    if (!selectAll) {
      this.importProspects.forEach(item => {
        item.IsSelected = trueOrfalse;
        if (trueOrfalse) {
          if (this.selectedProspects.findIndex(x => x.Id == item.Id) < 0) {
            this.selectedProspects.push(item);
          }
        }
        else {
          this.selectedProspects.splice(this.selectedProspects.findIndex(x => x.Id == item.Id), 1);
        }
      });
      if (!trueOrfalse) {
        this.selectAllProspects = false;
      }
    }
    else {
      this.allProspects.forEach(item => {
        item.IsSelected = trueOrfalse;
        if (trueOrfalse) {
          if (this.selectedProspects.findIndex(x => x.Id == item.Id) < 0) {
            this.selectedProspects.push(item);
          }
        }
        else {
          this.selectedProspects.splice(this.selectedProspects.findIndex(x => x.Id == item.Id), 1);
        }
      });
      this.dtElement.dtInstance.then(x => x.draw());
    }

    if (this.allProspects.length == this.selectedProspects.length) {
      this.hideselectionLinks = true;
    }
    else {
      this.hideselectionLinks = false;
    }
  }

  onSelectedProspectsRemove(Id: number) {
    this.selectedProspects.splice(this.selectedProspects.findIndex(x => x.Id == Id), 1);
    this.selectAllProspects = false;
    let currentItem = this.importProspects.find(f => f.Id == Id);
    if (currentItem != null) {
      currentItem.IsSelected = false;
    }
  }
  onPreviewRemove(Id: number) {
    this.selectedProspectList.splice(this.selectedProspectList.findIndex(x => x.Id == Id), 1);
    this.selectAllProspects = false;
    let currentItem = this.importProspects.find(f => f.Id == Id);
    if (currentItem != null) {
      currentItem.IsSelected = false;
    }
    this.selectedProspects.splice(this.selectedProspects.findIndex(x => x.Id == Id), 1);
  }


  loadNewWidget(currentWidget: number, type: string) {
    let nextMenu = 1;
    if (type == 'Back') {
      nextMenu = currentWidget == 1 ? this.menu.SelectedProperties : currentWidget == 2 ? this.menu.SelectedProperties : this.menu.ImportProspects;
    }
    else if (type == 'Next') {
      nextMenu = currentWidget == 1 ? this.menu.ImportProspects : currentWidget == 2 ? this.menu.Preview : this.menu.SelectedProperties;
    }
    else if (type == 'PreviewandImport') {
      nextMenu = this.menu.Preview;
    }
    this.setMenuID(nextMenu);
  }

  getNotesData(currentimport: IProspectDetailsModel[]) {
    this.IsShowCollapse = false;
    let currentNotes = [];
    currentimport.forEach(itemNotes => {
      if (itemNotes.Notes != null && itemNotes.Notes != '') {
        currentNotes = itemNotes.Notes.split('\\');
        if (currentNotes != null && currentNotes.length > 0) {
          let latestPropertyNote = [];
          let AllLatestPropertyNote = [];
          let index = 0;
          currentNotes.forEach(item => {
            if (item != '' && item != null && item != "") {
              let newnotes = item.split('||');
              if (newnotes != null) {
                let shortNote = (newnotes[0] + '-' + newnotes[2]);
                let balance = (newnotes[0] + ' - ').length;
                balance = balance > 0 ? this.characterLimit - balance : this.characterLimit;
                const Note = {
                  PropertyName: newnotes[0],
                  PropertyGuid: newnotes[1],
                  Notes: shortNote.length > this.characterLimit ? (newnotes[2].substring(0, balance) + '...') : newnotes[2],
                  NoteData: shortNote,
                  LengthExceeded: (newnotes[0] + ' - ' + newnotes[2]).length > this.characterLimit ? true : false
                };
                const Note1 = {
                  PropertyName: newnotes[0],
                  PropertyGuid: newnotes[1],
                  Notes: newnotes[2],
                  NoteData: shortNote,
                  LengthExceeded: (newnotes[0] + ' - ' + newnotes[2]).length > this.characterLimit ? true : false
                };
                if (index <= 1) {
                  latestPropertyNote.push(Note);
                }
                AllLatestPropertyNote.push(Note1);
                index = index + 1;
              }
            }
          });
          itemNotes.ProspectNotes = latestPropertyNote;
          itemNotes.AllProspectNotes = AllLatestPropertyNote;
          if ((itemNotes.AllProspectNotes != null && itemNotes.AllProspectNotes.length >= 3) || (itemNotes.ProspectNotes != null && itemNotes.ProspectNotes.findIndex(f => f.LengthExceeded) > -1)) {
            itemNotes.IsShowCollapse = true;
          }
          else {
            itemNotes.IsShowCollapse = false;
          }
          itemNotes.IsShowFullNotes = false;
        }
      }
    });
  }

  showFullNotes(prospects: any) {
    prospects.IsShowFullNotes = true;
  }
  hideFullNotes(prospects: any) {
    prospects.IsShowFullNotes = false;
  }
  scrollToTop(element, offset) {
    //this.scrollService.scrollTo(element, offset);
    $('html,body').animate({ scrollTop: ($(element).offset().top - offset) }, 500);
  }
  onSearch(text: string) {
    $(".dataTables_paginate.paging_full_numbers").hide();
    if (this.activeMenu == this.menu.ImportProspects || this.activeMenu == this.menu.Preview) {
      this.apiUrl = '/property/importProspectList';
    }
    else if (this.activeMenu == this.menu.SelectedProperties) {
      this.propertySearchNote1 = text;
      this.apiUrl = '/property/GetImportProspectPropertyList';
    }
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }

  setPropertyList(result: any) {
    this.importProperties = result.data;
    if (this.importProperties != null && this.importProperties.length > 0) {
      if (this.selectedRows.length > 0) {
        this.selectedRows.forEach(item => {
          if (this.importProperties.findIndex(f => f.Id == item.Id) >= -1) {
            let currentData = this.importProperties.find(f => f.Id == item.Id);
            if (currentData != null) {
              currentData.IsSelected = true;
            }
          }
        });
        if (this.importProperties.findIndex(f => !f.IsSelected || f.IsSelected == null) > -1) {
          this.selectAll = false;
        }
        else {
          this.selectAll = true;
        }
      }
      else {
        this.selectAll = false;
      }
    }
    else {
      this.selectAll = false;
      this.importProperties = [];
    }
  }

  hideselectionLinks = false;
  setProspectList(result: any) {
    this.importProspectInputModel.Search = this.prospectSearch;
    this.importProspectInputModel.PropertyLst = this.selectedRows.map(i => i.Id);

    this._propertyListingService.GetAllImportProspect(this.importProspectInputModel).subscribe((response: IProspectDetailsModel[]) => {
      this.allProspects = response ? response : [];
      this.allProspectCount = this.allProspects.length;
    });
    let currentProspects = this.selectedProspects;
    this.importProspects = result.data;
    if (this.importProspects != null && this.importProspects.length > 0) {
      if (this.importProspects != null && this.importProspects.length > 0) {
        this.getNotesData(this.importProspects);
      }
      if (currentProspects != null && currentProspects.length > 0) {
        currentProspects.forEach(item => {
          if (this.importProspects.findIndex(f => f.Id == item.Id) >= -1) {
            let currentData = this.importProspects.find(f => f.Id == item.Id);
            if (currentData != null) {
              currentData.IsSelected = true;
            }
          }
        });
        if (this.importProspects.findIndex(f => !f.IsSelected) > -1) {
          this.selectAllProspects = false;
        }
        else {
          this.selectAllProspects = true;
        }
      }
      else {
        this.selectAllProspects = false;
      }
    }
    else {
      this.selectAllProspects = false;
      this.importProspects = [];
    }
  }

  setPreviewList(result: any) {
    this.selectedProspectList = result.data;
    if (this.selectedProspectList != null && this.selectedProspectList.length > 0) {
      if (this.selectedProspectList != null && this.selectedProspectList.length > 0) {
        this.getNotesData(this.selectedProspectList);
        this.selectedProspectList.forEach(item => {
          if (this.selectedProspects.findIndex(f => f.Id == item.Id) >= -1) {
            item.IsSelected = true;
          }
          else {
            item.IsSelected = false;
          }
        });
      }
    }
    else {
      if (result.data == null || result.data.length == 0) {
        this.selectedProspectList = [];
      }
    }
  }

  removeProspects(removedData: any) {
    if (removedData != null && this.selectedProspects.length > 0) {
      if (this.selectedProspects.findIndex(f => f.Id == removedData.Id) > -1) {
        this.selectedProspects.splice(this.selectedRows.findIndex(x => x.Id == removedData.Id), 1);
      }
      if (this.selectedProspectList.findIndex(f => f.Id == removedData.Id) > -1) {
        this.selectedProspectList.splice(this.selectedRows.findIndex(x => x.Id == removedData.Id), 1);
      }
    }
  }

  saveImportProspect() {
    if (this.selectedProspects != null && this.selectedProspects.length > 0) {
      const saveProspectModel = {
        PropertyId: this.propertyId,
        ProspectMasterIds: this.selectedProspects.map(i => i.Id),
        LoggedInUserId: this.user.Id,
        OfferOnId: this.OfferOnId
      }
      this._dashboardService.saveImportProspects(saveProspectModel).subscribe(res => {
        if (res) {
          this._toastService.addToast({ title: 'Success', msg: "Prospects saved successfully.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
          this.save.emit(saveProspectModel);
        }
        else {
          this._toastService.addToast({ title: 'Error', msg: "Something went wrong.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        }
      })
    }
    else {
      this._toastService.addToast({ title: 'Error', msg: "Please select Prospects", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
    }
  }

  onViewAllProperties() {
    this.IsSelectedPropertyOpened = true;
  }
  onViewAllPreview() {
    this.IsSelectedPreviewOpened = true;
  }
  onViewAllProspects() {
    this.IsSelectedProspectOpened = true;
  }

  hideAllProperties() {
    this.IsSelectedPropertyOpened = false;
  }
  onHidePreview() {
    this.IsSelectedPreviewOpened = false;
  }
  onHideProspects() {
    this.IsSelectedProspectOpened = false;

  }

  getAssetTypes() {
    var that = this;
    that._commonService.getTypeList().subscribe(response => {
      that.inputAssetTypes = response.map(o => {
        return { id: o.Id, name: o.Type };
      });

    });
  }

  bindSubCategoroes(event = null) {
    this.inputSubCategory = [];
    if (this.selectedAssetTypes.length > 0) {
      var that = this;
      this._commonService.getSubcategoryList(this.selectedAssetTypes).subscribe(res => {
        if (res.length > 0) {
          that.inputSubCategory = res.map(o => {
            return { id: o["Id"], name: o["Name"] };
          });
          if (this.selectedSubCategories != null && this.selectedSubCategories.length > 0) {
            this.selectedSubCategories = this.selectedSubCategories.filter(o => that.inputSubCategory.some(({ id, name }) => o === id));
          }
        }
        else {
          that.selectedSubCategories = [];
        }
      });
    }
    else {
      this.inputSubCategory = [];
      this.selectedSubCategories = [];
    }
  }

  onPropertySearch() {
    $(".dataTables_paginate.paging_full_numbers").hide();
    if (this.activeMenu == this.menu.ImportProspects || this.activeMenu == this.menu.Preview) {
      this.apiUrl = '/property/importProspectList';
    }
    else if (this.activeMenu == this.menu.SelectedProperties) {
      this.apiUrl = '/property/GetImportProspectPropertyList';
    }
    if (this.searchNote != null && this.searchNote != null) {
      let searchText = this.searchNote;
      this.saveSearchFilter();
      this.dtElement.dtInstance.then(x => x.search(searchText).draw());
    }
    else {
      this.saveSearchFilter();
      this.dtElement.dtInstance.then(x => x.draw());
    }
  }

  saveSearchFilter() {
    if (this.activeMenu == this.menu.SelectedProperties) {
      this.selectedSubCategoriesCopy = this.selectedSubCategories.map(o => o);
      this.selectedAssetTypesCopy = this.selectedAssetTypes.map(o => o);
      this.selectedBrokersCopy = this.selectedBrokers.map(o => o);
      this.selectedSearch = this.searchNote;
    }
    else if (this.activeMenu == this.menu.ImportProspects) {
      this.prospectSearch = this.searchNote;

    }
    else {
      this.previewSearch = this.searchNote;
    }
  }

  getBrokers() {
    this._propertyManagementService.getBrokers(0).subscribe(response => {
      if (response.length > 0) {
        this.inputBroker = response.map(o => {
          return { id: o["Id"], name: o["Name"] };
        });
      }
    });
  }

  onResetClick() {
    if (this.activeMenu == this.menu.SelectedProperties) {
      this.selectedAssetTypes = [];
      this.selectedSubCategories = [];
      this.selectedBrokers = [];
      this.selectedAssetTypesCopy = [];
      this.selectedSubCategoriesCopy = [];
      this.selectedBrokersCopy = [];
      this.searchNote = '';
      this.selectedSearch = '';
      this.IsArchived = false;
    }
    else if (this.activeMenu == this.menu.ImportProspects) {
      this.searchNote = '';
      this.prospectSearch = '';
    }
    else {
      this.searchNote = '';
      this.previewSearch = '';
    }
    this.dtElement.dtInstance.then(x => x.search('').draw());
  }

  showArchivedProperties() {
    this.apiUrl = '/property/GetImportProspectPropertyList';

    if (this.searchNote != null && this.searchNote != null) {
      let searchText = this.searchNote;
      this.dtElement.dtInstance.then(x => x.search(searchText).draw());
    }
    else {
      this.saveSearchFilter();
      this.dtElement.dtInstance.then(x => x.draw());
    }
  }
}

